/**
 * @fileoverview GET handler for the "/api/calculated_attributes/:app_group_id/tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { apiCalculatedAttributesAppGroupIdTags } from "./constants";
import type { GetApiCalculatedAttributesAppGroupIdTagsResult } from "./types";

export const getApiCalculatedAttributesAppGroupIdTags = reactQueryFetcherAdapter(
  apiCalculatedAttributesAppGroupIdTags,
  (signal: AbortSignal, appGroupId: string): Promise<GetApiCalculatedAttributesAppGroupIdTagsResult> => {
    return fetch(`/api/calculated_attributes/${appGroupId}/tags`, "GET", undefined, { signal });
  }
);
